module.exports = [{"color":"#257833","name":"顺意","kol":"638","mua":"340"},{"color":"#560669","name":"中立","kol":"327","mua":"109"},{"color":"#606518","name":"逆意","kol":"1098","mua":"399"}]


//////////////////
// WEBPACK FOOTER
// ./src/routes/customChart/Favor/data.json
// module id = 3497
// module chunks = 1